/**
 * Draw interaction event types
 * @type {{DRAWEND: string, DRAWSTART: string}}
 */
const DrawEventType = {
  DRAWSTART: 'drawstart',
  DRAWEND: 'drawend'
};

export default DrawEventType;
